<template>
    <div class="action-wrapper">
        <div class="name-wrapper" @mouseover="hoverHandler(true)" @mouseout="hoverHandler(false)">
            <div class="name" :class="{ 'name-empty': !node.name }" @dblclick="doubleClick">
                <el-tooltip class="item" :content="node.name || '双击编辑「执行动作」'" placement="right-start">
                    <span class="action-content"> <i class="action-node" />{{ node.name || "双击编辑「执行动作」" }}</span>
                </el-tooltip>
                <NodeOperateIcon
                    v-show="showOperate"
                    @mouseover="hoverHandler(true)"
                    @mouseout="hoverHandler(false)"
                    @edit="doubleClick"
                    @delete="deleteHandler"
                />
            </div>
        </div>
        <div class="next" :id="nextId" v-if="nextId">
            <el-tooltip :content="node.actions[0].desc" placement="right-start">
                <span class="action-content">{{ node.actions[0].desc || "" }}</span>
            </el-tooltip>
            <div class="add-after" @click="afterClick"></div>
        </div>
    </div>
</template>

<script>
import NodeOperateIcon from "./common/NodeOperateIcon";
import ActionEditModal from "./actionEditModal/ActionEdit";

export default {
    name: "Action",
    props: ["node", "nodes"],
    data() {
        return {
            showOperate: false
        };
    },
    components: {
        NodeOperateIcon
    },
    computed: {
        nextId() {
            return this.node.actions && this.node.actions[0] ? this.node.actions[0].actionId : "";
        }
    },
    methods: {
        doubleClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: ActionEditModal,
                data: {
                    title: "设置执行动作", //i18n.t
                    rpaId: this.node.rpaId,
                    nodeId: this.node.id,
                    nodeType: this.node.nodeType,
                    submit: async () => {
                        this.$emit("nodeClick", { node: this.node, operator: "edited" });
                    }
                }
            });
        },
        hoverHandler(flag) {
            this.hoverTimeout && clearTimeout(this.hoverTimeout);
            if (!flag) {
                this.hoverTimeout = setTimeout(() => {
                    this.showOperate = flag;
                }, 500);
                return;
            }
            this.showOperate = flag;
        },
        afterClick() {
            this.$emit("connect", { origEvent: event, node: this.node, sourceId: this.nextId, type: ["new", "connect"] });
        },
        deleteHandler() {
            this.$emit("nodeClick", { node: this.node, operator: "delete" });
        }
    }
};
</script>

<style lang="less" scoped>
@import (reference) url("./common/rpaNode.less");
.action-wrapper {
    .rpa-node-wrapper();
    &:hover {
        box-shadow: 0 0 6px 0 #C8D8E5;
    }
}
.name-wrapper {
    .rpa-name-wrapper();
}
.name {
    .rpa-name("@{zhijiStaticImagePath}rpa-node-action.png");
    .item {
        display: inline-block;
        width: 180px;
    }
}
.name-empty {
    color: #999999;
}
.next {
    .rpa-content(#d7f1eb);
    position: relative;
    &:hover {
        border: 1px solid #C8D8E5;
        box-shadow: 0 0 4px 0 #C8D8E5;
        background-color: #EAFCF8;
    }
}
.action-content {
    .single-line-ellipsis();
}
.add-after {
    position: absolute;
    right: -32px;
    bottom: 10px;
    display: inline-block;
    width: 31px;
    height: 21px;
    background: url("@{zhijiStaticImagePath}add-action-node.png");
}
.next.jtk-connected {
    .add-after {
        display: none;
    }
}
</style>
